/* How long a saved file's blob: URL stays alive: some browsers only start reading it after the click has returned. */
const OBJECT_URL_LIFETIME_MS = 30_000

/**
 * Saves `contents` as a file for the person using the app, through a hidden <a download>. Only ever a save: the
 * browser writes the file and opens nothing, whatever `options.type` says.
 *
 * `contents` is anything a Blob is built from: text, an ArrayBuffer or typed array (a workbook from SheetJS or
 * ExcelJS), or a Blob. The Code Widget's wistor.exportAsFile ends here too, in the host's document.
 */
export function exportAsFile(
  contents: BlobPart,
  desiredFilename: string,
  options?: BlobPropertyBag,
) {
  const objectURL = URL.createObjectURL(new Blob([contents], options))
  const hiddenElement = document.createElement('a')
  try {
    hiddenElement.setAttribute('style', 'display: none;')
    hiddenElement.download = desiredFilename
    hiddenElement.href = objectURL
    hiddenElement.rel = 'noopener'

    document.body.appendChild(hiddenElement) // required for firefox
    hiddenElement.click()
  } finally {
    hiddenElement.remove()
    /* Not at once: revoking straight after click() can cancel the save before the browser has read the file. */
    setTimeout(() => URL.revokeObjectURL(objectURL), OBJECT_URL_LIFETIME_MS)
  }
}
